/* ===========================================================
 * de.js
 * German translation for Trumbowyg
 * http://alex-d.github.com/Trumbowyg
 * ===========================================================
 * Author : Manfred Timm
 *          Github : https://github.com/Manfred62
 */

jQuery.trumbowyg.langs.de = {
    viewHTML: 'HTML anzeigen',

    formatting: 'Formatieren',
    p: 'Absatz',
    blockquote: 'Zitat',
    code: 'Code',
    header: 'Überschrift',

    bold: 'Fett',
    italic: 'Kursiv',
    strikethrough: 'Durchgestrichen',
    underline: 'Unterstrichen',

    strong: 'Wichtig',
    em: 'Betont',
    del: 'Gelöscht',

    unorderedList: 'Ungeordnete Liste',
    orderedList: 'Geordnete Liste',

    insertImage: 'Bild einfügen',
    insertVideo: 'Video einfügen',
    link: 'Link',
    createLink: 'Link einfügen',
    unlink: 'Link entfernen',

    justifyLeft: 'Links ausrichten',
    justifyCenter: 'Zentrieren',
    justifyRight: 'Rechts ausrichten',
    justifyFull: 'Blocksatz',

    horizontalRule: 'Horizontale Linie einfügen',

    fullscreen: 'Vollbild',

    close: 'Schliessen',

    submit: 'Bestätigen',
    reset: 'Rücksetzen',

    required: 'Erforderlich',
    description: 'Beschreibung',
    title: 'Titel',
    text: 'Text'
};